// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"225":"910f1f5d","307":"a3b5af71","525":"54b86a62","660":"fbf0d4a0","808":"e213c374"}[chunkId] + ".chunk.css";
};